import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router';
import { Button, LINK_CLASS, Notice } from '@efira/ui';

import { useCurrentUser } from '../auth/session';
import { AuthLayout } from './AuthLayout';

/**
 * Подтверждение почты.
 *
 * Сюда Better Auth возвращает после перехода по ссылке из письма: успех - без
 * параметров, негодная ссылка - с ?error. Экран различает три состояния:
 * подтверждено, ссылка истекла, и «ссылка уже была использована» - последнее
 * выглядит для пользователя как успех, если он уже вошёл.
 */
export function VerifyEmailScreen() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user, loading } = useCurrentUser();

  const error = params.get('error');
  const [redirectIn, setRedirectIn] = useState(3);

  const verified = error === null;

  useEffect(() => {
    if (!verified || loading || user === null) {
      return;
    }

    if (redirectIn <= 0) {
      void navigate('/app', { replace: true });
      return;
    }

    const id = window.setTimeout(() => {
      setRedirectIn((value) => value - 1);
    }, 1000);

    return () => {
      window.clearTimeout(id);
    };
  }, [verified, loading, user, redirectIn, navigate]);

  if (!verified) {
    return (
      <AuthLayout
        title="Ссылка больше не работает"
        footer={
          <RouterLink className={LINK_CLASS} to="/login">
            Перейти ко входу
          </RouterLink>
        }
      >
        <Notice tone="warning" title="Срок ссылки истёк">
          Ссылка подтверждения действует ограниченное время. Войдите — и мы предложим отправить
          новую.
        </Notice>

        <div className="mt-2 flex flex-col gap-3">
          <Button
            variant="primary"
            block
            onClick={() => {
              void navigate('/login');
            }}
          >
            Перейти ко входу
          </Button>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Почта подтверждена">
      <Notice tone="success" title="Готово">
        Адрес подтверждён.{' '}
        {user !== null ? `Открываем dashboard через ${redirectIn}…` : 'Теперь можно войти.'}
      </Notice>

      <div className="mt-2 flex flex-col gap-3">
        <Button
          variant="primary"
          block
          onClick={() => {
            void navigate(user !== null ? '/app' : '/login');
          }}
        >
          {user !== null ? 'В dashboard' : 'Войти'}
        </Button>
      </div>
    </AuthLayout>
  );
}
